import React, { HTMLProps } from 'react';
import { IconElements } from '../../../../config/icons';
import { Pill } from '../../../general/Pill';
import { Button } from '../../../general/Button';

export const OverlayTableHeader: React.FC<
    {
        title?: string;
        selectionYears?: number[];
        onClose?: () => void;
        onExportCSV: () => void;
        selectedYear: number;
        onYearSelected: (year: number) => void;
    } & HTMLProps<HTMLDivElement>
> = ({ title, selectionYears, onClose, selectedYear, onYearSelected, className, onExportCSV, ...rest }) => {
    return (
        <div {...rest} className={`shadow-xl flex flex-col py-4 px-4 flex-start sm:px-8 gap-2 ${className}`}>
            <div className="flex flex-row justify-between">
                <div className="flex items-start" style={{ flexGrow: 1 }}>
                    <span className="text-3xl">{title}</span>
                </div>
                <div className="flex flex-row items-start ">
                    <YearPills
                        className="hidden lg:flex ml-8 mt-2"
                        style={{ flexGrow: 2 }}
                        selectedYear={selectedYear}
                        years={selectionYears || []}
                        onYearSelected={onYearSelected}
                    />
                    <div className="flex flex-row lg:items-center items-start">
                        <ExportCSVButton onExportCSV={onExportCSV} className="hidden lg:flex ml-8 shrink-0" />
                        {onClose && (
                            <button
                                className="ml-8 text-2xl flex items-center focus:outline-none cursor-pointer"
                                onClick={() => {
                                    onClose();
                                }}
                            >
                                <IconElements.Cross className="text-bnd-green w-6 h-6 sm:h-8 sm:w-8 hover:text-green-400 transition" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex lg:hidden flex-row flex-1 justify-between lg:justify-end">
                <div className="flex flex-col lg:flex-row gap-4">
                    <YearPills
                        className="lg:hidden"
                        selectedYear={selectedYear}
                        years={selectionYears || []}
                        onYearSelected={onYearSelected}
                    />
                    <ExportCSVButton className="lg:hidden" onExportCSV={onExportCSV} />
                </div>
            </div>
        </div>
    );
};

const ExportCSVButton: React.FC<{ onExportCSV: () => void } & HTMLProps<HTMLDivElement>> = ({
    onExportCSV,
    className,
    ...rest
}) => {
    return (
        <Button onClick={onExportCSV} buttonType="secondary" className={className}>
            <span className="flex flex-row justify-between items-center ">
                <IconElements.CopySheet className="mr-4" />
                <span>Export naar Excel / CSV</span>
            </span>
        </Button>
    );
};

const YearPills: React.FC<
    { selectedYear: number; years: number[]; onYearSelected: (year: number) => void } & HTMLProps<HTMLDivElement>
> = ({ selectedYear, years, onYearSelected, className, ...rest }) => {
    return (
        <div className={`flex flex-row flex-wrap gap-2 text-lg items-center ${className}`} {...rest}>
            {years.map((year, index) => {
                return (
                    <Pill
                        className={`text-sm sm:text-base flex items-center`}
                        tint="green"
                        key={index}
                        isActive={year === selectedYear}
                        onClick={() => onYearSelected(year)}
                    >
                        {year}
                    </Pill>
                );
            })}
        </div>
    );
};
